<nb-card>
  <nb-card-header>
    <span>Lịch sử</span>
  </nb-card-header>

  <nb-list class="user-activity-list">
    <nb-list-item *ngFor="let item of exerciseUsers; let i = index">
      <div class="exercise-date">
        <div class="caption">Lần: {{ exerciseUsers.length - i }}</div>
        <div class="value">
          <ngx-view-time-ago [currentDate]="item.updatedOn"></ngx-view-time-ago>
        </div>
      </div>

      <div class="exercise-pages-count">
        <div class="caption">Đúng</div>
        <div class="value">{{ item.noCorrect }} / {{ item.noQuiz }}</div>
      </div>

      <div class="exercise-percentages">
        <div class="caption">Kết quả, % / giây</div>
        <div
          class="delta value"
          [class.up]="item.percentage >= item.percentCompleted"
          [class.down]="item.percentage < item.percentCompleted"
        >
          <nb-icon
            [icon]="
              item.percentage > item.percentCompleted
                ? 'arrow-up'
                : 'arrow-down'
            "
            pack="eva"
          ></nb-icon>
          <span *ngIf="item.finished">
            {{ item.percentage }} /
            {{ item.timeSpent ? (item.timeSpent.toFixed(0) | number) : "." }}s
          </span>

          <span *ngIf="!item.finished" style="color: #0095ff">
            {{ i == 0 ? "đang thi" : "bỏ qua" }}
          </span>
        </div>
      </div>

      <div class="exercise-status">
        <div class="caption">Trạng thái</div>

        <div
          class="delta value"
          [class.up]="item.finished && item.percentage >= item.percentCompleted"
          [class.down]="
            !item.finished || item.percentage < item.percentCompleted
          "
        >
          <nb-icon
            [icon]="
              item.finished && item.percentage >= item.percentCompleted
                ? 'checkmark-circle'
                : 'alert-circle-outline'
            "
            pack="eva"
          ></nb-icon>
        </div>
      </div>
    </nb-list-item>
  </nb-list>
</nb-card>
